<template>
  <v-dialog v-model="dialog" width="530">
    <v-card>
      <v-row class="pt-4 pb-2 mr-4" no-gutters justify="end">
        <v-icon @click="$emit('closeModal')">mdi-close</v-icon>
      </v-row>

      <v-card-text class="pa-0 ma-0">
        <v-row v-if="!loading" no-gutters justify="center">
          <div id="challenge"></div>
        </v-row>

        <v-row v-else no-gutters justify="center" class="pa-16">
          <v-progress-circular
            indeterminate
            size="100"
            color="primary"
          ></v-progress-circular>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  props: ["showModal3DS", "data3ds", "transactionId"],

  data() {
    return {
      dialog: false,
      loading: false,

      inverval: null,
      timeout: null,
    };
  },

  computed: {
    ...mapGetters(["orderDetails", "eventId"]),
  },

  methods: {
    createIFrame() {
      try {
        var iframe = document.createElement("iframe");
        iframe.name = "myframe";
        iframe.id = "myframe";
        iframe.height = "492px";
        iframe.width = "492px";
        iframe.frameBorder = "0";

        const div = document.getElementById("challenge");

        div.appendChild(iframe);

        var idocument = iframe.contentWindow.document;

        var myform = idocument.createElement("form");
        myform.name = "myform";
        myform.setAttribute("target", "myframe");
        myform.setAttribute("method", "post");
        myform.setAttribute("action", this.data3ds.url);

        var hiddenField = idocument.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "creq");
        hiddenField.setAttribute("value", this.data3ds.creq);
        myform.appendChild(hiddenField);
        iframe.appendChild(myform);

        myform.submit();
      } catch (error) {
        alert("Error doing Challenge, try again later.");
      }
    },

    async checkPurchaseStatus() {
      let headers = { checkout: "one-checkout" };

      const { data } = await axios.get(
        `pdv/orders/charge/status?order_hash=${this.orderDetails?.hash_pedido}`,
        null,
        { headers }
      );

      const { payments } = data;

      if (payments && payments.length) {
        let findedPayment = payments.find(
          (p) => Number(p.tid) === Number(this.transactionId)
        );

        if (findedPayment && findedPayment.status === "C") {
          this.$emit("closeModal");
          this.$store.dispatch("openSnackbar", {
            message: "Error ao validar",
            color: "error",
          });

          return;
        }
      }

      if (data.orderStatus === "P" && this.dialog) {
        setTimeout(() => {
          this.checkPurchaseStatus();
        }, 5000);
      } else if (data && data.status === "paid") {
        this.$store.commit("SET_FINAL_DETAILS", data);
        this.$router.push({
          name: "Finished",
          params: { event: this.eventId },
          query: this.$route.query,
        });
        this.$emit("closeModal");
      }
    },

    checkIfConfirmationIsValid() {
      this.timeout = setTimeout(() => {
        if (this.dialog) {
          this.$emit("closeModal");
          this.$store.dispatch("openSnackbar", {
            message: "Validação expirada",
            color: "error",
          });
        }
      }, 300000);
    },
  },

  watch: {
    showModal3DS(v) {
      this.dialog = v;
    },

    dialog(v) {
      if (v) {
        this.loading = false;
        this.$store.commit("SET_SECURE_3DS_OPEN", true);
        this.checkIfConfirmationIsValid();

        window.addEventListener("message", (e) => {
          if (e.data.status === "COMPLETE") {
            this.loading = true;
          }
        });

        setTimeout(() => {
          this.createIFrame();
        }, 600);

        this.checkPurchaseStatus();
      } else {
        clearTimeout(this.timeout);
      }
    },
  },
};
</script>
